<template>
  <c-date-picker
    v-model="rangeTo"
    :limit-from="limitFrom"
    :limit-to="limitTo"
    :bold="isRangeTypeInterval"
    title="по"
    form-group
    form-group-margin-bottom
    width="100px"
  />
</template>

<script>
import CDatePicker from '../../../../../../../resources/js/components/ui/CDatePicker'
import { mapGetters, mapActions } from 'vuex'

/**
 * Input для выбора даты по какой период показывать отчет.
 */
export default {
  name: 'PeriodRangeToInput',
  components: {
    CDatePicker
  },
  props: {
    /**
     * Левая граница выбора даты.
     */
    limitFrom: {
      validator (value) {
        return ['object', 'string', 'number'].includes(typeof value) || value === null
      },
      default: null
    },
    /**
     * Правая граница выбора даты.
     */
    limitTo: {
      validator (value) {
        return ['object', 'string', 'number'].includes(typeof value) || value === null
      },
      default: null
    }
  },
  computed: {
    /**
     * Дата по какой период показать отчет.
     */
    rangeTo: {
      get () {
        return this.$store.state.seo.positionsFilter.rangeTo
      },
      set (value) {
        this.changeRangeTo(value)
      }
    },
    ...mapGetters({
      isRangeTypeInterval: 'seo/positionsFilter/isRangeTypeInterval'
    })
  },
  methods: {
    ...mapActions({
      changeRangeTo: 'seo/positionsFilter/changeRangeTo'
    })
  }
}
</script>
